module.exports = __webpack_public_path__ + "img/bg1.abf7d82e.jpg";